import { useCallback } from 'react';
import type { FilterType, FilterValueUrlParser } from '../types';
import { getFilterValidator } from '../validation';

export const useFreeFormHubInputValidator = (type: FilterType) =>
  useCallback<FilterValueUrlParser<typeof type>>(urlValue => getFilterValidator(type)(urlValue), [type]);
